import { useCallback, useEffect, useState } from 'react'
import { supabase } from './supabase'
import { useSupabaseAuth } from './useSupabaseAuth'
import { getCompanyId } from './supabase'

export const usePlan = () => {
  const { user } = useSupabaseAuth()
  const [plan, setPlan] = useState('free')
  const [status, setStatus] = useState('inactive')
  const [seatsLimit, setSeatsLimit] = useState(0)
  const [companyId, setCompanyId] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const load = useCallback(async () => {
    if (!user?.id) return
    setLoading(true)
    setError('')
    try {
      const cid = await getCompanyId(user)
      setCompanyId(cid || null)
      if (!cid) {
        setPlan('free')
        setStatus('inactive')
        setSeatsLimit(0)
        return
      }
      const { data, error } = await supabase
        .from('companies')
        .select('plan_tier, plan_status, seats_limit')
        .eq('id', cid)
        .single()
      if (error) throw error
      setPlan(data?.plan_tier || 'free')
      setStatus(data?.plan_status || 'inactive')
      setSeatsLimit(data?.seats_limit || 0)
    } catch (err) {
      setError(err.message || 'Failed to load plan')
    } finally {
      setLoading(false)
    }
  }, [user?.id])

  useEffect(() => {
    load()
  }, [load])

  return { plan, status, seatsLimit, companyId, loading, error, reloadPlan: load }
}

export const PlanGate = ({ required = ['solo','team','business'], children, fallback = null }) => {
  const { plan, loading } = usePlan()
  if (loading) return null
  return required.includes(plan) ? children : (fallback || null)
}

